export const textColor = {
  error: "#d82424",
  complete: "#04c09e",
  default: "#525252",
} as const;
